import ReportSnapshot from './reportSnapshot'
export default ReportSnapshot
